import api from "../api/axios"

export const getSubscriptionPlans = async () => {
  const res = await api.get("/subscription-plans")
  return res.data
}

/** Formules avec le tarif « formule » pour le pack choisi (prix dépend du pack). */
export const getSubscriptionPlansForPack = async (packId) => {
  const res = await api.get(`/packs/${packId}/subscription-plans`)
  return res.data
}

export const getSubscriptionPlan = async (id) => {
  const res = await api.get(`/subscription-plans/${id}`)
  return res.data
}

export const createSubscriptionPlan = async (data) => {
  const res = await api.post("/subscription-plans", data)
  return res.data
}

export const updateSubscriptionPlan = async (id, data) => {
  const res = await api.put(`/subscription-plans/${id}`, data)
  return res.data
}

export const deleteSubscriptionPlan = async (id) => {
  const res = await api.delete(`/subscription-plans/${id}`)
  return res.data
}
